import { Flex, Box } from "@chakra-ui/react";
import ListingPageHeaderBar from "ui/components/Page/ListingPageHeaderBar/index";
import useFiltroClientes from "../../hooks/useFiltroClientes";
import { useState } from "react";
import PageHeader from "components/Page/PageHeader";
import NewTable from "components/NewTable";
import useClientesColumns from "./../../hooks/useClientesColumns";
import DashboardClientes from "../DashboardClientes";
import history from "infra/helpers/history";
import { showConfirm } from "infra/helpers/alerta";
import ModalFiltroClientes from "./../ModalFiltroClientes/";
import useClientes from "core/features/cliente/hooks/useClientes";
import useDeleteCliente from "core/features/cliente/hooks/useDeleteCliente";
import TableTags from "../TableTags";
import { VscFile } from "react-icons/vsc";
import { IoMdTrash } from "react-icons/io";
import { useLoading } from "components/GlobalLoading";

export default function ListaClientes() {
  const { filtro, onChangeFiltro, onResetFiltro } = useFiltroClientes();
  const [isOpenModalFiltro, setIsOpenModalFiltro] = useState(false);
  const columns = useClientesColumns();
  const { data, isLoading, isFetching, refetch } = useClientes(filtro);

  const { mutate: excluirCliente, isLoading: isLoadingExcluir } =
    useDeleteCliente();

  const numeroFiltroSelecionados =
    (filtro.documento ? 1 : 0) +
    (filtro.tempoFimContrato || filtro.tipoIntervaloTempoFimContrato ? 1 : 0) +
    (filtro.situacao ? 1 : 0);

  useLoading(isLoadingExcluir || isLoading);

  return (
    <>
      <PageHeader
        title="Clientes"
        mb="24px"
        titleButton={"Adicionar Cliente"}
        onClick={() => history.push("/cadastros/clientes/novo")}
      />

      <DashboardClientes />

      <Box mb={6}>
        <ListingPageHeaderBar
          valueSearch={filtro.search}
          onSearch={(search) => onChangeFiltro({ search })}
          visibleFiltro
          badge
          badgeValue={numeroFiltroSelecionados}
          onFiltro={() => setIsOpenModalFiltro(true)}
          children={
            <Flex justifyContent="space-between" w="100%" alignItems="center">
              <TableTags
                value={filtro.situacao}
                onChange={(v) => onChangeFiltro({ situacao: v ?? undefined })}
              />
            </Flex>
          }
          showOrderByButton
          orderByOptions={[
            {
              value: "createdAt",
              label: "Data de cadastro",
            },
            {
              value: "fimContrato",
              label: "Dias para o fim do contrato",
            },
            {
              value: "nome",
              label: "Nome",
            },
          ]}
          orderBy={filtro.orderBy}
          onOrderByChange={(orderBy) => {
            onChangeFiltro({
              orderBy,
            });
          }}
          orderDirection={filtro.orderDirection}
          onOrderDirectionChange={(orderDirection) => {
            onChangeFiltro({
              orderDirection,
            });
          }}
        />
      </Box>

      <Box>
        <NewTable
          columns={columns}
          dataSource={data?.items ?? []}
          loading={isLoading || isFetching}
          actions={[
            {
              title: "Editar",
              icon: () => <VscFile size={20} />,
              onClick: (v) => history.push(`/cadastros/clientes/${v.id}`),
            },
            {
              title: "Excluir",
              icon: () => <IoMdTrash size={20} />,
              onClick: (v) => {
                showConfirm("Deseja realmente excluir o cliente?").then(
                  ({ isConfirmed }) => {
                    if (isConfirmed) {
                      excluirCliente(v.id, {
                        onSuccess: () => refetch(),
                      });
                    }
                  }
                );
              },
            },
          ]}
        />
      </Box>
      {isOpenModalFiltro ? (
        <ModalFiltroClientes
          onClose={() => setIsOpenModalFiltro(false)}
          open={isOpenModalFiltro}
          filtro={filtro}
          onChangeFiltro={onChangeFiltro}
          onReset={onResetFiltro}
        />
      ) : null}
    </>
  );
}
